module.exports = __webpack_public_path__ + "static/img/jszc_qr.415bba14.png";